import React, { Component } from "react";
import {
  getStore,
  updateMaterial,
  deleteMaterial,
} from "../../Redux/materialRedux/materialAction";
import { connect } from "react-redux";
import { useTheme } from "@material-ui/core/styles";
import {
  Dialog,
  TextField,
  DialogActions,
  DialogContent,
  useMediaQuery,
  DialogContentText,
  Button,
  DialogTitle,
  CardContent,
  Typography,
  Grid,
  Card,
} from "@material-ui/core";
import _ from "lodash";
import Editlist from "./Editlist";
import Loading from "../../Components/Loading";
//import Box from '@mui/material/Box';
//import { DataGrid } from '@mui/x-data-grid';
import MUIDataTable from "mui-datatables";
class DisplayMaterial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      store: [],
      open: false,
      itemName: "",
      rate: 0,
      unit: "",
      editIndex: 0,
      nameError: false,

      rowsPerPage:50,
      page:null
    };
  }
  handleFieldsChange = async (name, value) => {
    let found = false;
    if (name === "itemName") {
      this.props.storeData.forEach(material => {
        if (material.materialName === value.trim()) {
          found = true;
          return;
        }
      });
      if (found) {
        this.setState({ nameError: true });
        //return;
      } else {
        this.setState({ nameError: false });
      }
    }
    if (this.state[name] != value)
      await this.setState({
        [name]: value,
      });

    console.log("staet is ", this.state[name], value);
  };
  async componentDidUpdate() {
    if (this.state.store.length !== this.props.storeData.length) {
      var tempMaterials = new Set();
      (() => {
        this.props.storeData.map(ele => {
          return tempMaterials.add(ele);
        });
        this.setState({
          store: Array.from(tempMaterials),
        });
      })();
      
    }
  }
  async componentDidMount() {
    await this.props.getStore();

    if (!this.props.getStoreLoading) {
      console.log("materials data", this.props.storeData);
      this.setState({
        store: this.props.storeData,
      });
    }
  }
  deleteMaterial = i => {
    let id = this.state.store[i]._id;
    var arr = [...this.state.store];
    arr.splice(i, 1);
    this.props.deleteMaterialItem(id);
  };
  handleEdit = (itemName, unit, rate, rowIndex) => {
    this.setState({
      itemName,
      rate,
      unit,
      open: true,
      editIndex: rowIndex,
    });
  };
  handleModalOpen = () => {
    this.setState({
      open: false,
      itemName: "",
      rate: 0,
      unit: "",
      editIndex: 0,
      nameError: false,
    });
  };
  handlesubmit = () => {
    if(this.state.nameError) return
    console.log("handlesubmit ", this.state.unit);
    let new_items = this.state.store;
    new_items[this.state.editIndex] = {
      ...new_items[this.state.editIndex],
      materialName: this.state.itemName,
      materialRate: this.state.rate,
      materialUnit: this.state.unit,
    };
    let id = this.state.store[this.state.editIndex]._id;
    this.props.updateMaterialItem(id, new_items[this.state.editIndex]);

    this.setState({
      open: false,
      store: new_items,
    });
  };
  columns = [
    {
      name: "materialName",
      label: "Material",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "materialUnit",
      label: "Unit",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "materialRate",
      label: "Rate",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Edit",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <button
              onClick={() => {
                console.log("values of edit", value, tableMeta);
                this.handleEdit(
                  tableMeta.rowData[0],
                  tableMeta.rowData[1],
                  tableMeta.rowData[2],
                  tableMeta.rowIndex
                );
              }}
            >
              Edit
            </button>
          );
        },
      },
    },
    {
      name: "Delete",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <button onClick={() => this.deleteMaterial(tableMeta.rowIndex)}>
              Delete
            </button>
          );
        },
      },
    },
  ];

  render() {
    return (
      <>
        {this.props.getStoreLoading ? (
          <Loading loading={this.props.loading} />
        ) : (
          <div className="container mt-2" style={{ marginBottom: "1em" }}>
            <h3 className="mt-4 mb-3">Materials Registered</h3>
            <Editlist
              itemName={this.state.itemName}
              unit={this.state.unit}
              rate={this.state.rate}
              open={this.state.open}
              handleModalOpen={this.handleModalOpen}
              handlesubmit={this.handlesubmit}
              handleFieldsChange={this.handleFieldsChange}
              nameError={this.state.nameError}
            />
            {this.state.store.length > 0 && (
              <MUIDataTable
                title={`Materials`}
                data={this.state.store}
                columns={this.columns}
                options={{
                  selectableRows: "none",
                  responsive: "simple",
                  pagination: true,
                  download: false,
                  viewColumns: false,
                  filter: true,
                  print: false,
                  rowsPerPage: this.state.rowsPerPage,
                  onChangeRowsPerPage: (numberOfRows) => {
                    this.setState({
                      rowsPerPage: numberOfRows,
                    });
                  },
                  onTableChange: (action, tableState) => {
                    if (action === "changePage") {
                      this.setState({
                        page: tableState.page,
                      });
                      console.log(tableState.page, "table state");
                    } else {
                      console.log("action not handled.");
                    }
                  }
                }}
              />
            )}
          </div>
        )}
      </>
    );
  }
}
//

const mapStateToProps = state => {
  return {
    getStoreLoading: state.materialReducer.getStoreLoading,
    storeData: state.materialReducer.storeData,
  };
};

export default connect(mapStateToProps, {
  getStore,
  updateMaterial,
  deleteMaterial,
})(DisplayMaterial);
